/**
 * Makes a request to the browser to make an element be displayed in fullscreen mode
 * @param {Element} element the component that will become fullscreen
 */
export const toggleFullscreen = element => {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    // Firefox
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    // Chrome, Safari, and Opera
    element.webkitRequestFullscreen();
  }
};

/**
 * Requests that the element on this document which is currently being presented
 * in fullscreen mode be taken out of fullscreen mode,
 * restoring the previous state of the screen
 */
export const exitFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozExitFullScreen) {
    document.mozExitFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
};

const UNDEFINED = 'undefined';
export const getBrowserFullscreenElementProp = () => {
  if (typeof document.fullscreenElement !== 'undefined') {
    return 'fullscreenElement';
  } else if (typeof document.mozFullScreenElement !== UNDEFINED) {
    return 'mozFullScreenElement';
  } else if (typeof document.msFullscreenElement !== UNDEFINED) {
    return 'msFullscreenElement';
  } else if (typeof document.webkitFullscreenElement !== UNDEFINED) {
    return 'webkitFullscreenElement';
  } else {
    throw new Error('fullscreenElement is not supported by this browser');
  }
};
